import { ZodSafeParseResult, ZodType } from "zod/v4";

export const parseZodError = (schema: ZodType<any>, value: unknown): string => {
  const result = schema.safeParse(value) as ZodSafeParseResult<any>;
  if (!result.success) {
    return result.error.issues[0]?.message ?? "";
  }
  return "";
};

export const parseMultiFieldZodError = <T>(
  schema: ZodType<T>,
  data: T,
  fieldKey: keyof T
): string => {
  const result = schema.safeParse(data);
  if (!result.success) {
    for (const issue of result.error.issues) {
      const pathFirst = issue.path[0];
      const validType =
        typeof pathFirst === "string" || typeof pathFirst === "number";

      if (validType && String(pathFirst) === String(fieldKey)) {
        return issue.message;
      }
    }
  }
  return "";
};

export const generateFieldIndex = (index: number) => {
  return index + 1;
};

export const validationCurrentIndex = (index: number, currentIndex: number) => {
  return currentIndex > index;
};
